<button class="vl-button" (click)="triggerFileInputClick()">{{ 'UPLOAD.LABEL' | translate }}</button>
<input type="file" #fileInput (change)="onFileSelected($event)" accept=".csv" style="display: none" />
